module.exports = __webpack_public_path__ + "91e2c6b1440cff40ee79c9d0de59cbcb.jpg";